/** The public demo is entered only through the Google-authenticated launcher. */

import { useEffect } from 'react';
import { LoadingState } from '@/ui/primitives';

export function LoginPage() {
  useEffect(() => {
    window.location.replace('https://konnextions.marketingstudios.in/demo/');
  }, []);

  return (
    <div className="flex h-full items-center justify-center bg-bg">
      <LoadingState label="Returning to secure demo sign-in…" />
    </div>
  );
}
